
<div class="w-100 h-100" style="position: relative">
    <div class="poi-select">
        <v-btn
            class="dialog-button"
            style="font-size: 18px!important;font-family: Roboto, Arial, sans-serif!important;color: rgb(86, 86, 86)!important;"
            text
            @click = "onCenter"
        >
            {{ $t("disposition.map.center") }}
        </v-btn>
    </div>

    <div id="inspection-map"
         class = "google-map w-100 h-100"
         ref   = "googleMap"
    >
    </div>
</div>
